module.exports = __webpack_public_path__ + "static/media/features-split-top-03.cdefa3c4.png";